import * as React from 'react';

import styles from './appointment_book.module.scss';

interface StepHeadersProps {
  stepNumber: number;
  stepTitle: string;
}

const StepHeaders: React.FC<StepHeadersProps> = ({ stepNumber, stepTitle }) => (
    <>
      <hr className={`${styles.titleDivider} ${styles.titleDividerTop}`} />
      <h3 className={styles.titleBlock}>
        <span className={styles.stepNumber}>Step {stepNumber + 1} - </span>
        <span className={styles.stepTitle}>{stepTitle}</span>
      </h3>
      <hr className={`${styles.titleDivider} ${styles.titleDividerBottom}`} />
    </>
  );

export default StepHeaders;
